import {CommonMessages} from '../common.messages';

export const PanelClientsEditMessages = {
    GetExtendedIndividualFailed: {
        key: 'GetExtendedIndividualFailed',
        message: 'Error while communication with the server. Request for getting individual details failed.'
    },
    GetExtendedIndividualNotFound: {
        key: 'GetExtendedIndividualNotFound',
        message: 'Information about individual is not available.'
    },
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while communication with the server. Countries information is not available.'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Error while communication with the server. Countries information is invalid.'
    },
    SearchTradingClientFailed: {
        key: 'SearchTradingClientFailed',
        message: 'Error while communication with the server. Can\'t load individual trading details.'
    },
    SearchTradingClientNotFound: {
        key: 'SearchTradingClientNotFound',
        message: 'Can\'t find individual trading accounts.'
    },
    ActiveTradingAccountsNotFound: {
        key: 'ActiveTradingAccountsNotFound',
        message: 'Individual doesn\'t have active cash and trading accounts.'
    },
    GetIndividualStatusTriggersFailed: {
        key: 'GetIndividualStatusTriggersFailed',
        message: 'Error while communication with the server. Can\'t get individual status transitions.'
    },
    AddTradingAccountClientInactive: {
        key: 'AddTradingAccountClientInactive',
        message: 'New accounts could be added only for ACTIVE clients.'
    },
    GetAvailableTradingPlatformsFailed: {
        key: 'GetAvailableTradingPlatformsFailed',
        message: 'Error while communication with the server. Enable to get available trading platforms'
    },
    GetClientGroupsFailed: {
        key: 'GetClientGroupsFailed',
        message: 'Error while communication with the server. Enable to get created groups for client.'
    },
    UpdateTradingPlatformsFailed: {
        key: 'UpdateTradingPlatformsFailed',
        message: 'Error while request to the server. Unable to update trading platforms.'
    },
    UpdateTradingCategoryFailed: {
        key: 'UpdateTradingCategoryFailed',
        message: 'Error while request to the server. Unable to update client trading category.'
    },
    UpdateClientAliasFailed: {
        key: 'UpdateClientAliasFailed',
        message: 'Error while request to the server. Unable to update client alias.'
    },
    UpdateTradingCategoryOrClientAliasFailed: {
        key: 'UpdateTradingCategoryOrClientAliasFailed',
        message: 'Error while request to the server. Unable to update client trading category or alias.'
    },
    NotAssignedTradingPlatforms: {
        key: 'NotAssignedTradingPlatforms',
        message: 'The client hasn\'t assigned trading platforms.'
    },
    NotSupportedCreatingAccount: {
        key: 'NotSupportedCreatingAccount',
        message: 'Currently we don\'t support this operation for Fund portal users.'
    },
    GetIndividualAccountsFailed: {
        key: 'GetIndividualAccountsFailed',
        message: 'Error while communication with the server. Unable to get individual accounts.'
    },
    GetIndividualAccountsNoData: {
        key: 'GetIndividualAccountsNoData',
        message: 'Can\'t find individual accounts.'
    },
    GetIndividualAccountsRightsFailed: {
        key: 'GetIndividualAccountsRightsFailed',
        message: 'Error while communication with the server. Unable to get assigned account access rights to individual.'
    },
    GetPermissionsFailed: {
        key: 'GetPermissionsFailed',
        message: 'Error while communication with the server. Request for getting permissions failed.'
    },
    NoAccountsForSetup: {
        key: 'NoAccountsForSetup',
        message: 'Client already has assigned rights to all accounts or has not accounts for setup.'
    },
    GetPermissionsNoData: {
        key: 'GetPermissionsNoData',
        message: 'Can\'t find application permissions.'
    },
    ResetEmailPasswordFailed: {
        key: 'ResetEmailPasswordFailed',
        message: 'Error while communication with the server. Unable to <<resetItem>> email.'
    },
    UpdateContactDetailsFailed: {
        key: 'UpdateContactDetailsFailed',
        message: 'Error while request to the server. Unable to update contact details.'
    },
    MifirNumberIsWrong: {
        key: 'MifirNumberIsWrong',
        message: 'MiFIR Number must contain only Latin letters, numbers 0-9 and/or #.'
    },
    ...CommonMessages
};
